var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4209 15.8337H16.6667C17.5871 15.8337 18.3891 15.0636 18.0967 14.1908C17.651 12.8607 16.5546 12.0564 14.6273 11.7777M12.0834 9.05406C12.3259 9.13071 12.6037 9.16699 12.9167 9.16699C14.3056 9.16699 15 8.45271 15 6.66699C15 4.88128 14.3056 4.16699 12.9167 4.16699C12.6037 4.16699 12.3259 4.20327 12.0834 4.27992M7.91667 11.667C10.7363 11.667 12.323 12.4046 12.9763 13.8799C13.4236 14.8898 12.4379 15.8337 11.3333 15.8337H4.5C3.39543 15.8337 2.40976 14.8898 2.85702 13.8799C3.51034 12.4046 5.09706 11.667 7.91667 11.667ZM7.91667 9.16699C9.30556 9.16699 10 8.45271 10 6.66699C10 4.88128 9.30556 4.16699 7.91667 4.16699C6.52778 4.16699 5.83333 4.88128 5.83333 6.66699C5.83333 8.45271 6.52778 9.16699 7.91667 9.16699Z",
    stroke: "#DFD8D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.f0e363974b4ff987bf98288a461045f3.svg";
export { ForwardRef as ReactComponent };